/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Port_RequiredInputs */

const es_ab_err_port_required = /** @type {(inputs: Ab_Err_Port_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un puerto base`)
};

const gl_ab_err_port_required = /** @type {(inputs: Ab_Err_Port_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un porto base`)
};

const en_ab_err_port_required = /** @type {(inputs: Ab_Err_Port_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a home port`)
};

/**
* | output |
* | --- |
* | "Select a home port" |
*
* @param {Ab_Err_Port_RequiredInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_port_required = /** @type {((inputs?: Ab_Err_Port_RequiredInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Port_RequiredInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_port_required(inputs)
	if (locale === "en") return en_ab_err_port_required(inputs)
	return es_ab_err_port_required(inputs)
});